function filterNoisyInt(e, n, f, i, $r, c, data) {
  if (/^\s*>=\s*\d{1,}\s*$/.test(f)) {
    /* Greater Than or Equal To */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n >= parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*>\s*\d{1,}\s*$/.test(f)) {
    /* Greater Than */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n > parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*<=\s*\d{1,}\s*$/.test(f)) {
    /* Less Than or Equal To */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n <= parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*<\s*\d{1,}\s*$/.test(f)) {
    /* Less Than */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n < parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*=\s*\d{1,}\s*$/.test(f)) {
    /* Match */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n == parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*!=\s*\d{1,}\s*$/.test(f)) {
    /* Inverse Match */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n != parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*\d{1,}\s*-\s*\d{1,}\s*$/.test(f)) {
    /* Range */
    fa = f.match(/(\d{1,})\s*-\s*(\d{1,})/);
    if (fa && fa.length > 2) {
      return ((n >= parseInt(fa[1])) &&
              (n <= parseInt(fa[2])));
    } else {
      return false;
    }
  } else if (/^\s*\d{1,} to \d{1,}\s*$/.test(f)) {
    /* Range */
    fa = f.match(/(\d{1,}) to (\d{1,})/);
    if (fa && fa.length > 2) {
      return ((n >= parseInt(fa[1])) &&
              (n <= parseInt(fa[2])));
    } else {
      return false;
    }
  } else if (/^\s*\d{1,}\s*-\s*$/.test(f)) {
    /* Partial Range */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n >= parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*-\s*\d{1,}\s*$/.test(f)) {
    /* Partial Range */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n <= parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*!\s*\d{1,}\s*-\s*\d{1,}\s*$/.test(f)) {
    /* Inverse Range */
    fa = f.match(/(\d{1,})\s*-\s*(\d{1,})/);
    if (fa && fa.length > 2) {
      return ((n < parseInt(fa[1])) ||
              (n > parseInt(fa[2])));
    } else {
      return false;
    }
  } else if (/^\s*!\s*\d{1,} to \d{1,}\s*$/.test(f)) {
    /* Inverse Range */
    fa = f.match(/(\d{1,}) to (\d{1,})/);
    if (fa && fa.length > 2) {
      return ((n < parseInt(fa[1])) ||
              (n > parseInt(fa[2])));
    } else {
      return false;
    }
  } else if (/^\s*!\s*\d{1,}\s*-\s*$/.test(f)) {
    /* Inverse Partial Range */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n < parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*!\s*-\s*\d{1,}\s*$/.test(f)) {
    /* Inverse Partial Range */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n > parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*\d{1,}\s*$/.test(f)) {
    /* Match */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n == parseInt(fa[1]));
    } else {
      return false;
    }
  } else if (/^\s*!\s*\d{1,}\s*$/.test(f)) {
    /* Inverse Match */
    fa = f.match(/(\d{1,})/);
    if (fa && fa.length > 1) {
      return (n != parseInt(fa[1]));
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function extractDigits(node, table, cellIndex) {
  var da = $(node).text().match(/(\d{1,})/);
  if (da && da.length > 0) {
    return parseInt(da[1]);
  }
  return Number.MAX_VALUE;
}

// $(document).ready(function() {
//   $.tablesorter.addParser({
//     id : 'extract-digit',
//     is: function(s) {
//           return /\d{1,}/.test(s);
//         },
//     format: function(s) {
//               var num = s.match(/(\d{1,})/);
//               if (num && num.length > 0) {
//                 return num[1];
//               } else {
//                 return Number.MAX_VALUE;
//               }
//             },
//     // set type, either numeric or text
//     type: 'numeric'
//   });
// });
